import React from "react";
import  './footer.css';
import linkedinImg from '../../Images/SocialMedia/linkedin.png';
import xImg from '../../Images/SocialMedia/twitter.png';
import igImg from '../../Images/SocialMedia/instagram.png';
import fbImg from '../../Images/SocialMedia/facebook.png';
import dablerLogo from "../../../CommonImages/dabler4.png";
import { socialLinks } from "../../../../App";
import { Link } from "react-router-dom";

export default function Footer(props){

    return (
        <>
          <div className={"sf-footer-real-top"}>
            <div className={"sf-footer-top"}>
                <div className={"sf-company-details"}>
                    <div className={"sf-about-company"}>
                        <img src={dablerLogo} alt="dabler" />
                    </div>
                    <div className={"sf-company-add"}>
                        <h4>Address</h4>
                        <p>128 City Road, London,<br/> United Kingdom, EC1V 2NX</p>
                    </div>
                    <div className={"sf-company-email"}>
                        <div className={"sf-email-texts"}>
                            <h4>Email</h4>
                            <p>dabler@dabler.co.uk</p>
                        </div>
                    </div>
                </div>

                <div className={"sf-about-products sf-f-head-pad"}>
                    <div className={"sf-footer-col-head"}>Quick Links</div>
                    {/* <a href="#">Documentation</a>
                    <a href="#">Blogs</a> */}
                    <Link to={'/'}>Dabler</Link>
                    <Link to={'/datakob'}>DataKob</Link>
                    <Link to={'/acuber'}>Acuber AI</Link>
                </div>

                <div className={"sf-social-media sf-f-head-pad"}>
                    <div className={"sf-footer-col-head"}>Social Media</div>
                    <div className={"sf-social-container"}>
                        <a href={socialLinks.linkedIn}><img src={linkedinImg} alt="linkedIn" className={"sf-social-icon"}/></a>
                        {/* <a href={socialLinks.x}><img src={xImg} alt="x" className={"sf-social-icon"}/></a> */}
                        <a href={socialLinks.fb}><img src={fbImg} alt="fb" className={"sf-social-icon"}/></a>
                        {/* <a href={socialLinks.ig}><img src={igImg} alt="ig" className={"sf-social-icon"}/></a> */}
                    </div>
                </div>
            </div>
            
            <div className={"sf-copyright"}>
                <p className="mbr-text mb-0 mbr-fonts-style display-7">© Copyright DABLER - All Rights Reserved</p>
            </div>
          </div>
        </>
    )
}